module.exports = __webpack_public_path__ + "img/w3_rocket_black.996b58e5.png";